import { AfterViewInit, Component, QueryList, ViewChildren } from "@angular/core";
import { AccordionTab } from "primeng/accordion";
import { MessagingService } from "../../core/messaging/messaging.service";
import { SeverityType } from "../../core/messaging/severity-type.enum";

@Component({
  selector: "toolbox-modals-and-panels",
  templateUrl: "./modals-and-panels.component.html",
  styleUrls: ["./modals-and-panels.component.scss"],
})
export class ModalsAndPanelsComponent implements AfterViewInit {
  isModalVisible = false;
  isCollapsibleModalVisible = false;
  isConfirmationVisible = false;
  isResultVisible = false;

  @ViewChildren(AccordionTab) accordionTabs: QueryList<AccordionTab>;

  constructor(
    private messagingService: MessagingService
  ) { }

  ngAfterViewInit() {
    // AccordionTab is OnPush, and its ContentChildren(Header) query (which drives
    // whether the projected <p-header> renders) isn't guaranteed to be settled by the
    // time this fires. Deferring lets it settle, but an ancestor's detectChanges()
    // doesn't reliably cascade into this specific OnPush descendant, so we grab each
    // tab directly and force it individually, mirroring the tab-menu header fix.
    setTimeout(() => {
      this.accordionTabs.forEach(tab => tab.changeDetector.detectChanges());
    });
  }


  yesAction() {
    this.messagingService.showToast("You selected 'Yes'", SeverityType.SUCCESS);
  }

  noAction() {
    this.messagingService.showToast("You closed out!", SeverityType.INFO);
  }
}
